import * as Yup from 'yup'

export const validationSchema = Yup.object({
    name: Yup.string().required('Name field is required'),
    server: Yup.string().required('Server field is required'),
    databaseName: Yup.string().required('Database field is required'),
    userName: Yup.string().required('Username field is required')
})